import { englishValidationMessages } from './messages';
import { getMaxLengthValidator, getMinLengthValidator, getPatternValidator, zipCodeUsPatternValidator } from './rawValidators';
import { getRequiredValidator } from './required';
const maxLength = 10;
const minLength = 5;
const maxLengthValidator = getMaxLengthValidator(maxLength);
const minLengthValidator = getMinLengthValidator(minLength);
const postalCodePatternValidator = getPatternValidator(/^[0-9-]*$/);
export function getPostalCodeFailure(value) {
    const isValid = maxLengthValidator(value) && minLengthValidator(value) && zipCodeUsPatternValidator(value) && postalCodePatternValidator(value);
    return isValid ? null : 'invalid';
}
export const makePostalCodeValidators = (messages)=>{
    /** true means there's no error. false means there's an error. string means there's an error and gives the error-message. */ function getPostalCodeFailureMessages() {
        let valueName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : messages.fieldNames.postalCode;
        return {
            invalid: messages.invalid({
                field: valueName
            })
        };
    }
    function getPostalCodeValidator() {
        let valueName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : messages.fieldNames.postalCode, required = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        const requiredValidator = getRequiredValidator(required);
        const failureErrors = getPostalCodeFailureMessages(valueName);
        return (value)=>{
            const requiredError = requiredValidator(value);
            if (requiredError !== true) {
                return requiredError;
            }
            const failure = getPostalCodeFailure(value);
            return failure == null ? true : failureErrors[failure];
        };
    }
    /** For react-hook-form library. */ const postalCodeValidation = function postalCodeValidation(valueName) {
        let { required } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return {
            validate: {
                postalCode: getPostalCodeValidator(valueName, required)
            },
            dataAttr: {
                'data-validation': 'postal-code'
            }
        };
    };
    return {
        getPostalCodeFailureMessages,
        getPostalCodeValidator,
        postalCodeValidation
    };
};
export const { getPostalCodeFailureMessages, getPostalCodeValidator, postalCodeValidation } = makePostalCodeValidators(englishValidationMessages);
